import { ResultsExportType } from 'services/export/exportTypes';

export interface ResultsExportChoice {
  type: ResultsExportType;
  title: string;
  description: string;
  formTitle: string;
}

export const resultsExportChoices: ResultsExportChoice[] = [
  {
    type: 'published',
    title: 'Published study results',
    description: 'Whole study / published tables',
    formTitle: 'Export published study results',
  },
  {
    type: 'original',
    title: 'Original cell-table files',
    description: 'Parquet / stored analysis files, unchanged',
    formTitle: 'Export original cell-table files',
  },
  {
    type: 'intermediate',
    title: 'Intermediate job outputs',
    description: 'Segmentation, classification and feature-calculation files',
    formTitle: 'Export intermediate job outputs',
  },
  {
    type: 'features',
    title: 'Features',
    description: 'CSV / calculated feature values',
    formTitle: 'Export features',
  },
  {
    type: 'metadata',
    title: 'Metadata & forms',
    description: 'CSV / dataset metadata, QC labels and form responses',
    formTitle: 'Export metadata & forms',
  },
  {
    type: 'polygons',
    title: 'Selection / exclusion polygons',
    description: 'Existing polygon archive / whole, filtered, selected, or excluded cases',
    formTitle: 'Export selection / exclusion polygons',
  },
  {
    type: 'bundle',
    title: 'Bundled results',
    description: 'ZIP / configurable tables, prepared in the background',
    formTitle: 'Export bundled results',
  },
];
